'use strict'

module.exports = (function () {
    var autocomplete = require('autocompleter');
    /**
    * @ngdoc method
    * @name siteSearch
    * @description Initializes site search
    **/

    // Needs only be initialized once per page
    var initializeSiteSearch = function (inputId) {
        var searchResults = window.searchAutocomplete;

        var input = document.getElementById(inputId);
        var form = input.closest('form');
        var overlay = form.querySelector('.dropdown-overlay');
        var closeButton = form.querySelector('.close');

        if (typeof (form) !== "undefined") {
            input.addEventListener("focus", () => {
                form.classList.add('open');
            });

            closeButton.addEventListener('click', () => {
                form.classList.remove('open');
            });

            overlay.addEventListener('click', () => {
                form.classList.remove('open');
            });

            input.addEventListener('keyup', () => {
                if (!input.value.length) {
                    form.classList.add('open');
                }
            });
        }

        autocomplete({
            input: input,
            fetch: function (text, update) {
                form.classList.remove('open');
                text = text.toLowerCase();
                // you can also use AJAX requests instead of preloaded data
                var suggestions = searchResults.filter(n => _.some(n.label.toLowerCase().split(' '), w => w.startsWith(text)));
                update(suggestions);
            },
            onSelect: function (item) {
                window.location = item.value;
            }
        });
    };



    // Return an object exposing the public items
    return {
        initialize: initializeSiteSearch
    };

}())